import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-65fbeb50"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "delete-content" }
const _hoisted_2 = {
  class: "cm-ui-mb15",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_3 = { class: "cm-ui-ml10" }
const _hoisted_4 = { class: "sub-tips-1" }
const _hoisted_5 = { style: {"white-space":"wrap"} }
const _hoisted_6 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "append-to-body": "",
    modelValue: _ctx.modalVisiable,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modalVisiable) = $event)),
    "before-close": _ctx.closeModal,
    width: "470px"
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$t('groupClient.removeTerminalTitlePrefix')) + _toDisplayString(_ctx.row ? _ctx.row.computer_name : ''), 1)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_6, [
        _createVNode(_component_el_button, {
          size: "small",
          onClick: _ctx.closeModal
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          size: "small",
          type: "danger",
          onClick: _ctx.deleteTerminal
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.delete')), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_CmSvgIcon, {
            name: "assets/icons/delete",
            size: 24,
            color: "var(--el-color-danger)"
          }),
          _createTextVNode(),
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('groupClient.removeTerminalIrreversibleTip')), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_checkbox, {
            modelValue: _ctx.blackListFlag,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.blackListFlag) = $event))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('groupClient.removeTerminalBlacklistSameTime')) + _toDisplayString(_ctx.$t('groupClient.removeTerminalBlacklistHint')), 1)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "before-close"]))
}